<template>
  <div
    class="app-header-nav-content"
    :class="{ switchable: isSwitchableProfile }"
  >
    <div class="logo">
      <component :is="logoTag" aria-label="Accueil" class="logo-img" to="/" />
    </div>
    <div class="navigation">
      <AppHeaderNavigation
        v-if="!profile.needToDefineMainContent && navigation"
      />
    </div>
    <div class="actions" :class="{ 'has-feed': profile.featureFlags.feed }">
      <ButtonHeaderSubscribe
        v-if="
          !profile.needToDefineMainContent &&
          !profile.isASubscriber &&
          navigation
        "
        class="button-subscribe"
      />
      <AppHeaderAvatar
        v-if="!profile.needToDefineMainContent && navigation"
        class="avatar"
      />
      <AppHeaderFeed
        v-if="
          !profile.needToDefineMainContent &&
          profile.featureFlags.feed &&
          navigation
        "
        class="feed"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  navigation: boolean;
}

const props = defineProps({
  navigation: { type: Boolean }
});

const profile = useProfileStore();

const { isSwitchableProfile } = useFamilySwitchMember();

const logoTag = computed(() => {
  if (!profile.needToDefineMainContent && props.navigation) {
    return resolveComponent('NuxtLink');
  }
  return 'span';
});
</script>
<style lang="scss" scoped>
.app-header-nav-content {
  display: grid;
  position: relative;
  grid-template-areas: 'logo actions';
  grid-template-columns: 6rem var(--gap_xs) auto;
  grid-template-rows: 1fr;
  @include above('l') {
    grid-template-areas: 'logo navigation actions';
    grid-template-columns: 12rem 1fr auto;
  }

  align-items: center;
  height: 100%;

  .logo {
    grid-area: logo;
    width: 100%;
    height: 100%;
  }
  .logo-img {
    display: block;
    width: 100%;
    height: 100%;
    background-image: url('/images/logos/logo_nomad_color.svg');
    background-repeat: no-repeat;
    background-position: center;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: 22rem;
  text-align: left;
  justify-self: end;
  gap: var(--gap_n);
  @include above('l') {
    gap: var(--gap_m);
    justify-content: flex-end;
    max-width: none;
  }
}

.navigation {
  @include above('l') {
    grid-area: navigation;
  }
}
</style>
